import NoSleep from 'nosleep.js'

const noSleep = new NoSleep()

export default noSleep
